var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpperPriceIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.94782 3H20.0518C20.5728 3 20.9998 3.427 20.9998 3.948V4.052C20.9998 4.573 20.5728 5 20.0518 5H3.94782C3.42682 5 2.99982 4.573 2.99982 4.052V3.948C2.99982 3.427 3.42682 3 3.94782 3ZM12.7499 9.16388L12.7499 17.052C12.7499 17.573 12.3229 18 11.8019 18H11.6979C11.1769 18 10.7499 17.573 10.7499 17.052L10.7499 9.16388L9.45693 10.4569C9.06593 10.8479 8.43393 10.8479 8.04293 10.4569C7.84793 10.2619 7.74993 10.0059 7.74993 9.74987C7.74993 9.49387 7.84793 9.23887 8.04293 9.04287L11.0429 6.04287C11.4339 5.65287 12.0659 5.65287 12.4569 6.04287L15.4569 9.04287C15.8479 9.43388 15.8479 10.0669 15.4569 10.4569C15.0659 10.8479 14.4339 10.8479 14.0429 10.4569L12.7499 9.16388Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpperPriceIcon);
export default __webpack_public_path__ + "static/media/upper-price-icon.9f5c9e18.svg";
export { ForwardRef as ReactComponent };